module.exports = __webpack_public_path__ + "media/images/vouchers/spa_balneo-23671400a9d416a5a791d6b632736d9f.png";